export const extraLinks = [
  {
    id: "blog",
    label: "Blog",
    href: "https://www.lindseysblog.com",
    type: "website",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/lindsey-mayr-26528113b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    type: "linkedin",
  },
];
